if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          viewer: '[id^="GalleryViewer"]',
          thumbnails: '[id^="GalleryThumbnails"]',
          mediaList: '[id^="Slider-Gallery"]',
          mediaItems: ['.product__media-item'],
        };

        this.sliderInstance = false;
        this.thumbsInstance = false;
      }

      connectedCallback() {
        // this.init();
        FoxTheme.Motion.inView(this, this.init.bind(this));
      }

      init() {
        this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.mediaLayout = this.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === 'true';
        this.enableDesktopSlider = this.dataset.enableDesktopSlider === 'true';
        this.enableMobileThumbnails = this.dataset.enableMobileThumbnails === 'true';
        this.enableImageZoom = this.dataset.enableImageZoom === 'true';
        this.setSliderOptions();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.updateMediaLayout.bind(this);
        this.updateMediaLayout();
        const BM = window.BmPdpGalleryMatch;
        if (BM) this.setActiveMedia(BM.galleryVariantForProductInfo(this.getBmProductInfoRoot()));

        if (this.enableImageZoom) {
          this.initImageZoom();
        }
      }

      setSliderOptions() {
        const mediaItemGap = parseInt(this.dataset.mediaItemGap);

        this.sliderOptions = {
          init: false,
          slidesPerView: '1',
          spaceBetween: mediaItemGap,
          loop: false,
          grabCursor: true,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
          threshold: 2,
        };

        this.thumbsOptions = {
          slidesPerView: 4,
          breakpoints: {
            461: {
              slidesPerView: 5,
            },
          },
          spaceBetween: mediaItemGap,
          loop: false,
          freeMode: true,
          watchSlidesProgress: true,
          threshold: 2,
        };

        switch (this.mediaLayout) {
          case 'vertical-carousel':
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              breakpoints: {
                768: {
                  direction: 'vertical',
                  slidesPerView: 'auto',
                },
              },
            });
            break;
          case 'slider-freemode':
            this.sliderOptions = Object.assign({}, this.sliderOptions, {
              slidesPerView: 'auto',
            });
            break;
        }
      }

      updateMediaLayout() {
        if (FoxTheme.config.mqlMobile) {
          this.initSlider();
        } else {
          if (this.enableDesktopSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance !== 'object') {
          if ((this.enableDesktopSlider || this.enableMobileThumbnails) && this.elements.thumbnails) {
            this.thumbsInstance = new window.FoxTheme.Carousel(this.elements.thumbnails, this.thumbsOptions);
            this.thumbsInstance.init();

            this.sliderOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
              autoScrollOffset: 2,
            };
          }

          this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, [
            FoxTheme.Swiper.Thumbs,
          ]);
          this.sliderInstance.init();

          this.handleSliderAfterInit();
          this.handleSlideChange();

          this.sliderInstance.slider.init();
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      initThumbsSlider() {
        if (typeof this.thumbsInstance !== 'object') {
          this.thumbsInstance = new window.FoxTheme.Carousel(this.selectors.thumbnails, this.thumbsOptions);
          this.thumbsInstance.init();
        }
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = [...this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)')];
        if (allMedia) {
          allMedia.forEach((media) => {
            switch (media.dataset.mediaType) {
              case 'model':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('product-model').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'video':
              case 'external_video':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  html: `<div class="pswp__item--${media.dataset.mediaType}">${
                    media.querySelector('video-element').outerHTML
                  }</div>`,
                  mediaType: media.dataset.mediaType,
                });
                break;
              case 'image':
                dataSource.push({
                  id: media.dataset.mediaIndex,
                  src: media.dataset.src,
                  width: media.dataset.pswpWidth,
                  height: media.dataset.pswpHeight,
                  mediaType: media.dataset.mediaType,
                });
                break;
            }
          });
        }

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
        });

        this.lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el;
              }
            }
          }

          return thumbEl;
        });

        this.lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
          if (this.sliderInstance && this.sliderInstance.slider) {
            const { slides, activeIndex } = this.sliderInstance.slider;
            if (slides[activeIndex]) {
              const el = slides[activeIndex].querySelector('img');
              if (el) {
                return el.src;
              }
            }
          }

          return placeholderSrc;
        });

        this.lightbox.on('change', () => {
          window.pauseAllMedia(this);
        });

        this.lightbox.on('destroy', () => {
          const { currIndex } = this.lightbox.pswp;

          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideToLoop(currIndex, 0, false);
          }
        });

        this.lightbox.on('pointerDown', (e) => {
          if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
            e.preventDefault();
          }
        });

        this.lightbox.on('uiRegister', () => {
          if (!this.onlyImage) {
            this.lightbox.pswp.ui.registerElement({
              name: 'next',
              ariaLabel: 'Next slide',
              order: 3,
              isButton: true,
              html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.next();
              },
            });
            this.lightbox.pswp.ui.registerElement({
              name: 'prev',
              ariaLabel: 'Previous slide',
              order: 1,
              isButton: true,
              html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
              onClick: (event, el) => {
                this.lightbox.pswp.prev();
              },
            });
          }
          this.lightbox.pswp.ui.registerElement({
            name: 'close-zoom',
            ariaLabel: 'Close zoom image',
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        if (this.bmZoomDelegateBound) return;
        this.bmZoomDelegateBound = true;
        FoxTheme.utils.addEventDelegate({
          selector: '.js-photoswipe--zoom',
          context: this,
          handler: (e, media) => {
            if (media.dataset.mediaType === 'image') {
              const index = Array.from(this.querySelectorAll('.product__media-item')).indexOf(media);
              if (index < 0) return;
              this.lightbox.loadAndOpen(index);
            }
          },
        });
      }

      handleSliderAfterInit() {
        this.sliderInstance.slider.on('afterInit', (swiper) => {
          const { slides, activeIndex } = swiper;

          if (slides[activeIndex]) {
            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      handleSlideChange() {
        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { slides, activeIndex, thumbs } = swiper;

          if (thumbs.swiper) {
            thumbs.swiper.slideTo(activeIndex);
          }

          if (slides[activeIndex]) {
            this.playActiveMedia(slides[activeIndex]);

            const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
            this.toggleSliderDraggableState(!isModelMediaType);
          }
        });
      }

      toggleSliderDraggableState(isDraggable) {
        if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
          this.sliderInstance.slider.allowTouchMove = isDraggable;
        }
      }

      playActiveMedia(selected) {
        const deferredMedia = selected.querySelector('product-model');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      /**
       * Resolve the companion `<product-info>` so we can read the checked metal radio and its
       * BM display-name attribute (set by `snippets/product-metal-picker.liquid`). Needed because
       * metal display names from the Figma "Metal info" metaobject can differ from the raw
       * option value that ships in `variant.option1/2/3`.
       * @returns {HTMLElement|null}
       */
      getBmProductInfoRoot() {
        const prefix = 'MediaGallery-';
        if (!this.id || !this.id.startsWith(prefix)) return null;
        const sectionId = this.id.slice(prefix.length);
        return document.getElementById(`ProductInfo-${sectionId}`);
      }

      /**
       * Build a lowercase needle set from the selected variant's option values plus the currently
       * checked metal swatch's BM metal display name. Also expands common prefixes (e.g. `18k yellow
       * gold` -> `yellow gold`) so a single "Yellow Gold" image alt can match every carat variant
       * of that metal.
       * @param {Record<string, unknown>} [variant]
       * @returns {string[]}
       */
      getBmGalleryMatchContext(variant) {
        const BM = window.BmPdpGalleryMatch;
        if (!BM || typeof BM.buildMatchContext !== 'function') {
          return { needles: [], sku: '', shapeCode: '', metalCode: '' };
        }
        return BM.buildMatchContext(this.getBmProductInfoRoot(), variant);
      }

      /**
       * Prefer an explicit `data-bm-match-haystack` (future hook) then fall back to the primary
       * image alt on the slide.
       * @param {Element} mediaItem
       * @returns {string}
       */
      getBmMediaMatchHaystack(mediaItem) {
        if (!mediaItem) return '';
        const fromData = mediaItem.getAttribute('data-bm-match-haystack');
        if (fromData) return fromData;
        const img = mediaItem.querySelector(
          '.product__media img, .deferred-media__poster img, product-model img'
        );
        return (img && img.getAttribute('alt')) || '';
      }

      /**
       * Source URL / filename haystack for SKU-in-filename matching. Uses the Liquid-rendered
       * `data-src` on `.product__media-item` first (stable, always present), then falls back to
       * the primary image's `src` / `currentSrc`. Shopify's SKU-upload workflow drops the SKU
       * into the filename (e.g. `photo-hand-VMRNTQOV186WG.webp`, or comma-separated for multi-
       * variant images which Shopify URL-encodes as `_2C_`). A case-insensitive substring of the
       * variant's SKU is sufficient for both.
       * @param {Element} mediaItem
       * @returns {string}
       */
      getBmMediaSrcHaystack(mediaItem) {
        if (!mediaItem) return '';
        const dataSrc = mediaItem.getAttribute('data-src') || '';
        if (dataSrc) return dataSrc;
        const img = mediaItem.querySelector(
          '.product__media img, .deferred-media__poster img, product-model img'
        );
        if (!img) return '';
        return img.currentSrc || img.getAttribute('src') || '';
      }

      /**
       * Match needle in alt; numeric needles (e.g. carat `2.00`) must be bounded so `2.00` does
       * not match inside `12.00`.
       * @param {string} needle lowercased
       * @param {string} alt lowercased
       * @returns {boolean}
       */
      bmNeedleInAlt(needle, alt) {
        if (!needle || !alt) return false;
        if (/^\d+(\.\d+)?$/.test(needle)) {
          const esc = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          return new RegExp(`(?:^|[^0-9.])${esc}(?:[^0-9]|$)`).test(alt);
        }
        return alt.includes(needle);
      }

      bmScoreAltAgainstNeedles(altText, needles) {
        const alt = (altText || '').toLowerCase();
        if (!alt || !needles.length) return 0;
        let score = 0;
        for (const n of needles) {
          if (n && this.bmNeedleInAlt(n, alt)) score += 1;
        }
        return score;
      }

      /**
       * Score a slide by:
       *   1. SKU-in-filename match (`variant.sku` as a case-insensitive substring of the image
       *      src/data-src or alt). Weighted heavily (+100) so any deterministic SKU hit beats a
       *      loose alt-text match. This is the primary signal when merchants upload images with
       *      SKU-encoded filenames, which is the Bonded Matter workflow.
       *   2. Alt-text option-value needles (existing BM fallback for merchants who tag images
       *      with metal/stone words in the alt attribute).
       * @param {Element} mediaItem
       * @param {string} alt
       * @param {string[]} needles
       * @param {string} sku lowercased variant SKU ('' when unknown)
       * @returns {number}
       */
      bmScoreSlide(mediaItem, alt, ctx) {
        const BM = window.BmPdpGalleryMatch;
        const src = this.getBmMediaSrcHaystack(mediaItem) || '';
        const haystack = `${src} ${alt || ''}`.trim();
        if (BM && typeof BM.scoreHaystack === 'function') {
          return BM.scoreHaystack(haystack, ctx);
        }
        return this.bmScoreAltAgainstNeedles(alt, ctx.needles || []);
      }

      /**
       * Pick the slide that best matches the selected variant using SKU-in-filename first, then
       * alt-text option-value matching.
       * @param {string[]} needles
       * @param {string} sku lowercased variant SKU ('' when unknown)
       * @returns {{ id: string, position: number, score: number } | null} position is 1-based
       */
      findBestBmMediaMatch(ctx) {
        if (!ctx || (!ctx.needles.length && !ctx.sku && !ctx.shapeCode && !ctx.metalCode)) {
          return null;
        }
        const items = this.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');
        let bestItem = null;
        let bestScore = 0;
        let bestHaystack = '';
        for (const item of items) {
          const alt = this.getBmMediaMatchHaystack(item);
          const src = this.getBmMediaSrcHaystack(item) || '';
          const haystack = `${src} ${alt}`.trim();
          const score = this.bmScoreSlide(item, alt, ctx);
          if (score > bestScore) {
            bestScore = score;
            bestItem = item;
            bestHaystack = haystack;
          }
        }
        if (!bestItem || bestScore === 0) return null;
        const idx0 = parseInt(bestItem.dataset.mediaIndex, 10);
        const position = Number.isFinite(idx0) ? idx0 + 1 : 1;
        return {
          id: String(bestItem.dataset.mediaId),
          position,
          score: bestScore,
          haystack: bestHaystack,
        };
      }

      /**
       * Activate the slide matching the selected variant. Resolution order:
       *   1. Shopify admin-assigned `variant.featured_media` (per-variant media — wins ties).
       *   2. Bonded Matter SKU-in-filename match: `variant.sku` substring-matched against each
       *      slide's `data-src` / image `src`. This is the primary path in production because
       *      the merchant uploads images with SKU-encoded filenames (e.g. `photo-hand-
       *      VMRNTQOV186WG.webp`, comma-joined `…_2C_VMRNTQOV186WG…` for shared-metal images).
       *   3. Alt-text option-value needles (secondary fallback — metal/stone words in alt).
       *
       * Re-added in response to the regression where selecting yellow gold / white gold /
       * platinum or different stones never swapped the gallery image (cde0f56 removed the
       * fallback; SKU-filename match added here because Shopify left `variant.featured_media`
       * null despite SKU-encoded filenames — see PR discussion).
       */
      filterBmMedia(ctx) {
        const BM = window.BmPdpGalleryMatch;
        if (!BM || !this.elements || !this.elements.mediaList) return null;
        const group = BM.filterMediaGroup(this.elements.mediaList, '.product__media-item', ctx);
        this.elements.mediaItems = group.nodes;
        // Cache thumbnail nodes independently; absent variant nodes must leave navigation too.
        if (this.elements.thumbnails) {
          const wrapper = this.elements.thumbnails.querySelector('.swiper-wrapper');
          if (wrapper) {
            if (!this.bmAllThumbnails) this.bmAllThumbnails = Array.from(wrapper.children);
            const ids = new Set(group.nodes.map((node) => node.dataset.mediaId));
            this.bmAllThumbnails.forEach((node) => node.remove());
            this.bmAllThumbnails.filter((node) => ids.has(node.dataset.target)).forEach((node) => wrapper.appendChild(node));
            BM.refreshMediaSlider(this.thumbsInstance && this.thumbsInstance.slider);
          }
        }
        if (group.changed) {
          BM.refreshMediaSlider(this.sliderInstance && this.sliderInstance.slider);
          if (this.sliderInstance && this.sliderInstance.slider) this.sliderInstance.slider.slideTo(0, 0, false);
          if (this.enableImageZoom && this.lightbox) {
            this.lightbox.destroy();
            this.initImageZoom();
          }
        }
        return group.nodes;
      }

      setActiveMedia(variant) {
        const ctx = this.getBmGalleryMatchContext(variant);
        const BM = window.BmPdpGalleryMatch;
        this.filterBmMedia(ctx);
        const bmSlide = this.findBestBmMediaMatch(ctx);

        if (!variant) {
          if (!bmSlide || !bmSlide.id) return;
          if (this.sliderInstance.slider) {
            const slideIndex = Array.from(this.querySelectorAll('.product__media-item')).findIndex((node) => node.dataset.mediaId === String(bmSlide.id));
            if (slideIndex >= 0) this.sliderInstance.slider.slideTo(slideIndex, 0, false);
          }
          return;
        }

        let target =
          variant.featured_media && variant.featured_media.id
            ? {
                id: String(variant.featured_media.id),
                position: variant.featured_media.position || 1,
              }
            : null;

        if (bmSlide) {
          let featScore = 0;
          let featHaystack = '';
          if (target) {
            const featEl = this.querySelector(
              `.product__media-item[data-media-id="${target.id}"]`
            );
            const featAlt = this.getBmMediaMatchHaystack(featEl);
            featHaystack = `${this.getBmMediaSrcHaystack(featEl) || ''} ${featAlt}`.trim();
            featScore = this.bmScoreSlide(featEl, featAlt, ctx);
          }

          const preferred =
            BM && typeof BM.pickTargetFromScores === 'function'
              ? BM.pickTargetFromScores(featScore, featHaystack, bmSlide, ctx)
              : bmSlide.score > featScore
                ? bmSlide
                : null;

          if (!target) {
            target = { id: bmSlide.id, position: bmSlide.position };
          } else if (preferred) {
            target = { id: preferred.id, position: preferred.position };
          }
        }

        if (!target || !target.id || !this.querySelector(`.product__media-item[data-media-id="${target.id}"]`)) return;

        if (this.sliderInstance.slider) {
          const slideIndex = Array.from(this.querySelectorAll('.product__media-item')).findIndex((node) => node.dataset.mediaId === String(target.id));
          if (slideIndex >= 0) this.sliderInstance.slider.slideTo(slideIndex, 0, false);
        } else {
          this.sortMediaItems({ featured_media: target });
        }
      }

      sortMediaItems(variant) {
        let newMedias = this.elements.mediaItems;

        // Reset ordering.
        newMedias.sort(function (a, b) {
          return a.dataset.mediaIndex - b.dataset.mediaIndex;
        });

        newMedias.some((media, index) => {
          if (media.dataset.mediaId == variant.featured_media.id) {
            const [element] = newMedias.splice(index, 1);
            newMedias.unshift(element);
            return true;
          }
        });

        this.elements.mediaList.innerHTML = '';
        newMedias.forEach((media) => {
          this.elements.mediaList.appendChild(media);
        });

        if (!FoxTheme.config.mqlMobile) {
          const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
          if (selectedMedia) {
            window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
